import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import CSSRulePlugin from "gsap/CSSRulePlugin";
import { isMobile } from './exportFunc';
import animateSvg from "./animate-svg";

export default () =>{
    gsap.registerPlugin(ScrollTrigger);
	gsap.registerPlugin(CSSRulePlugin);
	let OFFSET, duration, delayEl;

	isMobile()?OFFSET = "top bottom-=50px":OFFSET = "top bottom-=150px";
	const DURATION = 1.5;
	const GLOBALDELAY = 3;
    //#region FADE ANIMATION 
		const fadeYElements = document.querySelectorAll('[animation-fadeY]');
		const fadeElements = document.querySelectorAll('[animation-fade]');

		fadeYElements.forEach(el =>{
            el.classList.contains('js-quick-appear')?OFFSET = "top bottom-=10px": false
            el.classList.contains('js-quick-appear')?duration =  DURATION/3:  DURATION/2
			const timeLine = gsap.timeline({
				scrollTrigger: {
					trigger: el,
					start: OFFSET, 
				},
			})
			timeLine.to(el,  {
				y: 0,
				ease: "Power1.easeOut",
				duration: DURATION,
				delay:0,
				onStart: ()=>{
					gsap.to(el,  {
						opacity: 1,
						ease: "Power1.easeIn",
						duration: duration,
						delay:0,
					});
				}
			});
		})
		
	
		fadeElements.forEach(el =>{
            el.classList.contains('js-quick-appear')?OFFSET = "top bottom-=10px": false;
            el.classList.contains('js-quick-appear')?duration =  DURATION/2:  DURATION;
			const timeLine = gsap.timeline({
				scrollTrigger: {
					trigger: el,
					start: OFFSET,
				},
			})
			timeLine.to(el,  {
				opacity: 1,
				ease: "power1.easeIn",
				duration: duration,
				delay:0.2,
			});
		})
	//#endregion


	//#region IMAGE PARALAX
		const paralaxImg = document.querySelectorAll('[animation-img-paralax]');
			
		paralaxImg.forEach(el =>{
			const timeLine = gsap.timeline({
				scrollTrigger: {
					trigger: el.closest("[paralax-wrapper]"), 
					start: "top 100%",
					end: "bottom 0%",
					scrub: !0,
				}
			})
			timeLine.to(el, { yPercent: 10 })
		})
	//#endregion

	//#region Titles Aniamtion
		const titles = document.querySelectorAll('[animate-titles]');
				
		titles.forEach(el =>{
			const timeLine = gsap.timeline({
				scrollTrigger: {
					trigger: el,
					start: OFFSET,
					
				}
			})
			splitTitles(el, timeLine, 0)
		})
		
		const quotes = document.querySelectorAll('.quote');

		quotes.forEach(el =>{
			const timeLine = gsap.timeline({
				scrollTrigger: {
					trigger: el.querySelector('.quote__inner'),
					start: OFFSET,
					delay: GLOBALDELAY,
					onEnter: ()=>{
						el.classList.add('animated')
					}
				}
			})
			
		})

	//#endregion

	//#region animateSvg
		const svgWrapper = document.querySelector('[animate-svg]');

		svgWrapper?svgHandle():false;

		function svgHandle(){
			const timeLine = gsap.timeline({
				scrollTrigger: {
					trigger: svgWrapper,
					start: OFFSET,
					onEnter: ()=>{
						animateSvg();
					}
				},
			})
		}
	//#endregion

	//#region quotes animation
		const quoteWrapers = document.querySelectorAll('[quote-main]');

		quoteWrapers.forEach(el =>{
			const title = el.querySelector('[quote-title]');
			const cta = el.querySelector('[quote-button]');

			const timeLine = gsap.timeline({
				scrollTrigger: {
					trigger: title,
					start: OFFSET,
				},
			})

			splitTitles(title, timeLine, 0);
			cta?animateCta():false;
			function animateCta(){
				timeLine.to(cta, {
					opacity: 1,
					ease: "power1.easeIn",
					duration: DURATION/2,
					delay: 0
				})
			}
			
		})
	//#endregion

	function splitTitles(title, timeLine, wordDelay){
		// //title split
		const oldHTML = title.innerHTML;
		let newHTML = '';
	
		let index = 0;
		while(index != -1) {
		const startIndex = index == 0 ? 0 : index + 1;
		if (oldHTML.indexOf(' ', index+2) != -1) {
			newHTML += `<span class="text-out"><span class="text-in">${oldHTML.slice(startIndex, oldHTML.indexOf(' ', index+2))}&nbsp;</span></span>`;
		} else {
			newHTML += `<span class="text-out"><span class="text-in">${oldHTML.slice(startIndex)}</span></span>`;
		}
		index = oldHTML.indexOf(' ', index+2);
		}
		title.innerHTML = newHTML;
		//eof title split
	
	
		// words reveal
		let words = title.querySelectorAll('.text-out');
		let wordIndex = 0;
		let wordOffset = -1;
		words.forEach(function(word) {
			if (word.innerHTML.includes('<br')) {
				word.classList.add('text-out--wrap');
			}
			if (word.offsetTop>wordOffset) {
				wordIndex++;
				wordOffset = word.offsetTop;
			}
			word.querySelector('.text-in').dataset.step = wordIndex
		});
		
		for (let i = 1; i <= wordIndex; i++) {
			let stepWords = title.querySelectorAll(`*[data-step="${i}"]`);
			timeLine.fromTo(stepWords, 
				{
					opacity:0,
					yPercent: 100
				},
				{
					opacity: 1,
					yPercent: 0,
					duration: DURATION,
					ease: 'expo',
				}, wordDelay
			)
			wordDelay = wordDelay + 0.5
		}
	}

}

